import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { CreateWoundDialogComponent } from '../../create-wound-dialog/create-wound-dialog.component';
import { WoundCareWidgetService } from '../../wound-care-widget.service';
import { WoundImagePreviewDialogComponent } from '../../wound-image-preview-dialog/wound-image-preview-dialog.component';
import { calculateTimeDifference, calculateArea, calculateVolume } from '../../wound-utils'

@Component({
  selector: 'app-wound-care-widget-child-item',
  templateUrl: './wound-care-widget-child-item.component.html',
  styleUrls: ['./wound-care-widget-child-item.component.css']
})
export class WoundCareWidgetChildItemComponent implements OnInit {

  @Input() provider;
  @Input() patient;
  @Input() childWound;
  @Input() readOnlyMode : any;
  @Input() actualParentWound;
  @Input() isPreview;
  @Output() WoundStatechange = new EventEmitter<any>();
  @Output() onICDsSave = new EventEmitter<any>();
  @Output() parentWoundDetailsChange = new EventEmitter<any>();
  mainImage: string;

  constructor(
    private dialog: MatDialog,
    private woundCareWidgetService: WoundCareWidgetService
  ) { }

  ngOnInit(): void {
    this.mainImage = this.childWound.wound_images[0];
  }

  calculateTimeDifference(wound) {
    return calculateTimeDifference(wound, this.actualParentWound);
  }
  calculateArea(wound) {
    return calculateArea(wound);
  }
  calculateVolume(wound) {
    return calculateVolume(wound);
  }
  handleChildWoundClick() {
    this.showWoundCreateDialog(this.childWound);
  }

  async showWoundCreateDialog(childWound) {
    let dialogRef = null;
    if(childWound._most_recent_wound === true){
      dialogRef = this.dialog.open(CreateWoundDialogComponent, {
        maxHeight: '90vh',
        maxWidth: '90vw',
        data: {
          provider: this.provider, patient: this.patient, wound: this.actualParentWound, childWound, onICDsSave: this.onICDsSave
        }
      });
      dialogRef.afterClosed().subscribe(async (data) => {
        if (data?.childWound) {
          this.childWound = Object.assign(this.childWound, data.childWound);
          if (data.wound.state != data.state) {
            this.WoundStatechange.emit(data.childWound);
            this.woundCareWidgetService.setState(true);
          }
        }
        if(data.updateData){
          this.parentWoundDetailsChange.emit(data.updateData)
        }
      });
    }else{
      dialogRef = this.dialog.open(CreateWoundDialogComponent, {
        maxHeight: '90vh',
        maxWidth: '90vw',
        data: {
          provider: this.provider, patient: this.patient, wound: null, childWound, onICDsSave: this.onICDsSave
        }
      });
    }
  }

  showWoundImagePreviewDialog(wound, imageIndex = 0) {
    const dialogRef = this.dialog.open(WoundImagePreviewDialogComponent, {
      width: 'auto',
      data: { wound: wound, imageIndex: imageIndex }
    });
  }
}
